import React from 'react';
import { Menu } from 'lucide-react';
import { useSidebar } from '../../contexts/SidebarContext';
import { useBranding } from '../../contexts/BrandingContext';

const DesktopHiddenBar: React.FC = () => {
  const { sidebarMode, openDesktopOverlay, isMobile } = useSidebar();
  const { config: brandingConfig } = useBranding();

  if (isMobile || sidebarMode !== 'hidden') return null;

  return (
    <header className="desktop-hidden-bar" role="banner">
      <button
        className="mobile-header__hamburger"
        onClick={openDesktopOverlay}
        aria-label="Открыть навигацию"
      >
        <Menu size={22} />
      </button>
      <div className="mobile-header__logo">
        <div className="mobile-header__logo-mark">
          <img src={brandingConfig?.logo_url || '/favicon.svg'} alt="" width={20} height={20} />
        </div>
        <span className="mobile-header__logo-title">
          {brandingConfig ? (
            brandingConfig.app_name
          ) : (
            <>Assistant <span className="text-primary-600">Business</span></>
          )}
        </span>
      </div>
    </header>
  );
};

export default React.memo(DesktopHiddenBar);
